export const OFFER_LOW_THRESHOLD = 0.8
export const OFFER_HIGH_THRESHOLD = 1.2

export type BenchmarkConfidence = 'high' | 'medium' | 'low'
export type OfferBenchmarkClassification = 'low' | 'expected' | 'high' | 'unavailable'

export type PricingBenchmark = {
  amountCents: number
  confidence: BenchmarkConfidence
}

function validBoundary(value: number | null | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
}

export function getPricingBenchmark(
  minimumCents: number | null | undefined,
  maximumCents: number | null | undefined,
): PricingBenchmark | null {
  const hasMinimum = validBoundary(minimumCents)
  const hasMaximum = validBoundary(maximumCents)

  if (!hasMinimum && !hasMaximum) return null
  if (!hasMinimum || !hasMaximum) {
    return { amountCents: hasMinimum ? minimumCents : maximumCents!, confidence: 'low' }
  }

  const amountCents = Math.round((minimumCents + maximumCents) / 2)
  const spreadRatio = Math.abs(maximumCents - minimumCents) / amountCents
  const confidence: BenchmarkConfidence = spreadRatio <= 0.2
    ? 'high'
    : spreadRatio <= 0.4
      ? 'medium'
      : 'low'

  return { amountCents, confidence }
}

export function classifyOfferAgainstBenchmark(
  offerCents: number | null | undefined,
  benchmarkCents: number | null | undefined,
): OfferBenchmarkClassification {
  if (!validBoundary(offerCents) || !validBoundary(benchmarkCents)) return 'unavailable'
  if (offerCents < benchmarkCents * OFFER_LOW_THRESHOLD) return 'low'
  if (offerCents > benchmarkCents * OFFER_HIGH_THRESHOLD) return 'high'
  return 'expected'
}
